export function exportToCsv(filename, columns, rows) {
  const header = columns.map((c) => c.label).join(',');
  const body = rows
    .map((row) =>
      columns
        .map((col) => {
          const val = col.exportValue ? col.exportValue(row) : col.render ? '' : row[col.key];
          const text = val == null ? '' : String(val).replace(/"/g, '""');
          return `"${text}"`;
        })
        .join(',')
    )
    .join('\n');
  const blob = new Blob([`${header}\n${body}`], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}

export function parseCsvText(text) {
  const lines = text.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length < 2) return [];
  const headers = lines[0].split(',').map((h) => h.replace(/^"|"$/g, '').trim());
  return lines.slice(1).map((line) => {
    const values = line.match(/("([^"]|"")*"|[^,]*)/g) || [];
    const row = {};
    headers.forEach((header, index) => {
      const raw = values[index] || '';
      row[header] = raw.replace(/^"|"$/g, '').replace(/""/g, '"').trim();
    });
    return row;
  });
}

export function downloadCsvTemplate(filename, columns, exampleRow = {}) {
  const cols = columns.map((col) => ({ label: col.label, key: col.key }));
  exportToCsv(filename, cols, [exampleRow]);
}
